import type { AxiosInstance } from 'axios';
import type { AnalyticsEvent } from './Analytics.types';

declare global {
  interface Window {
    gaGlobal: {
      from_cookie: boolean;
      hid: number;
      vid: string;
    };
  }
}

interface PushEventParams {
  referrer: string | null;
  experimentGroups?: string[];
  tries?: number;
  eventName: string;
  additionalParams?: Partial<Omit<AnalyticsEvent, 'name' | 'path' | 'url' | 'referrer' | 'googleId' | 'timestamp'>>;
}

/* TODO: Вернуть как было, когда найдем новый инструмент для сбора аналитики
    https://qicbizdev.atlassian.net/browse/QIC-4386 */
// let savedParams: { path: string; url: string } | null = null;

export function pushEvent(
  http: AxiosInstance,
  { referrer, experimentGroups = [], tries = 10, eventName, additionalParams }: PushEventParams,
) {
  if (!window?.gaGlobal) {
    if (tries < 0) {
      console.info(
        '%c[Push-event] `gaGlobal` not found 🤔',
        `background-color: #f94c27; color: white; font-size: 1.5rem;
         border-radius: 16px; padding: 12px 20px;`,
      );
      return;
    }
    return setTimeout(() => {
      pushEvent(http, { referrer, experimentGroups, tries: tries - 1, additionalParams, eventName });
    }, 500);
  }
  const clientId = window.gaGlobal.vid;
  const url = new URL(window.location.href);

  /* TODO: Вернуть как было, когда найдем новый инструмент для сбора аналитики
      https://qicbizdev.atlassian.net/browse/QIC-4386 */
  // if (savedParams) {
  //   const pathSame = savedParams.path === locationParams.path;
  //   const urlSame = savedParams.url === locationParams.url;
  //   if (pathSame && urlSame) {
  //     return Promise.resolve();
  //   }
  // }

  // savedParams = locationParams;

  const payload: Partial<AnalyticsEvent> = {
    name: eventName,
    path: window.location.pathname,
    url: window.location.href,
    referrer: referrer || document.referrer,
    googleId: clientId,
    timestamp: Math.floor(Date.now() / 1000),
    migration_flow: 'new',
    ...additionalParams,
  };

  // Add UTM parameters if present
  const utmSource = url.searchParams.get('utm_source');
  const utmMedium = url.searchParams.get('utm_medium');
  const utmCampaign = url.searchParams.get('utm_campaign');
  const utmTerm = url.searchParams.get('utm_term');
  const utmContent = url.searchParams.get('utm_content');

  if (utmSource) payload.utmSource = utmSource;
  if (utmMedium) payload.utmMedium = utmMedium;
  if (utmCampaign) payload.utmCampaign = utmCampaign;
  if (utmTerm) payload.utmTerm = utmTerm;
  if (utmContent) payload.utmContent = utmContent;

  const experimentGroupStr = experimentGroups.join(',');
  if (experimentGroupStr.length > 0) {
    payload.experimentGroup = experimentGroupStr;
  }

  return http.post('/events', payload);
}
